import NtxTable from '@components/DataTable/NtxTable';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';

import useGetPositions from '@hooks/HR/useGetPositions';
import useGetLocations from '@hooks/HRSetting/use-get-locations';
import useGetOrganizations from '@hooks/HR/use-get-organizations';
import useGetJobs from '@hooks/HR/useGetJobs';
import useGetGrade from '@hooks/HR/useGetGrade';
import useGetGroupEmp from '@hooks/HR/useGetGroupEmp';
import { Card, CardHeader } from '@components/card/card';
import { CardBody } from 'react-bootstrap';
import { Link } from 'react-router-dom';

// const Partial = ({ Persons, onIdsChange }) => {
//   const { t, i18n } = useTranslation();
//   const [selectedIds, setSelectedIds] = useState([]); // تخزين المعرفات المحددة

//   const { PositionsOptions } = useGetPositions();
//   const { LocationsOptions } = useGetLocations();
//   const { OrganizationOptions } = useGetOrganizations(); // جيب اللي نوعها HR  فقط
//   const { JobsOptions } = useGetJobs();
//   const { GradesOptions } = useGetGrade();
//   const { GroupEmpsOptions } = useGetGroupEmp();

//   useEffect(() => {
//     if (onIdsChange) {
//       onIdsChange(selectedIds);
//     }
//   }, [selectedIds, onIdsChange]);

//   // تحديث المعرفات عند تحديد أو إلغاء تحديد الموظف
//   const handleCheckboxChange = id => {
//     setSelectedIds(prev => (prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]));
//   };

//   // تحديد / إلغاء تحديد الجميع
//   const handleSelectAll = event => {
//     if (event.target.checked) {
//       setSelectedIds(Persons.map(item => item.assignmentId)); // إضافة جميع المعرفات
//     } else {
//       setSelectedIds([]); // إلغاء التحديد
//     }
//   };

//   const columns = [
//     {
//       title: (
//         <input
//           className='form-check-input'
//           type='checkbox'
//           onChange={handleSelectAll}
//           checked={selectedIds.length === Persons?.length && Persons?.length > 0}
//         />
//       ),
//       key: 'checkBox',
//       sortable: false
//     },
//     { title: t('EmployeeName'), key: 'Name' },
//     { title: t('EmployeeNumber'), key: 'num' },
//     { title: t('Payroll'), key: 'Payroll' }
//     // { title: t(''), key: 'action', className: 'text-end', sortable: false }
//   ];

//   const tableData = Persons?.map(item => {
//     return {
//       checkBox: (
//         <input
//           className='form-check-input'
//           type='checkbox'
//           checked={selectedIds.includes(item.assignmentId)}
//           onChange={() => handleCheckboxChange(item.assignmentId)}
//         />
//       ),
//       Name: i18n.language === 'ar' ? item.personName2 : item.personName,
//       num: item.employeeNumber,
//       Payroll: i18n.language === 'ar' ? item.payrollName2 : item.payrollName,
//       action: (
//         <>
//           <button
//             type='button'
//             data-bs-toggle='modal'
//             data-bs-target='#CreateQuickPay'
//             onClick={() => setPerson(item)}
//             className='btn btn-sm btn-outline-theme'
//           >
//             <i className='fas fa-lg fa-fw me-2 fa-money-bill-alt'></i>
//             {t('QuickPay')}
//           </button>
//         </>
//       )
//     };
//   });

//   return (
//     <>
//       <div className='row'>
//         <div className='col-lg-4 mb-3'>
//           <div className='input-group flex-nowrap'>
//             <span className='input-group-text text-theme fw-bold'>{t('الإدارة')}</span>

//             <Select
//               classNamePrefix='react-select'
//               className='w-100'
//               // isLoading={loading3}
//               isSearchable={true}
//               isClearable
//               options={OrganizationOptions}
//               placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//             />
//           </div>
//         </div>
//         <div className='col-lg-4 mb-3'>
//           <div className='input-group flex-nowrap'>
//             <span className='input-group-text text-theme fw-bold'>{t('المنصب')}</span>

//             <Select
//               classNamePrefix='react-select'
//               className='w-100'
//               // isLoading={loading3}
//               isSearchable={true}
//               isClearable
//               options={PositionsOptions}
//               placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//             />
//           </div>
//         </div>
//         <div className='col-lg-4 mb-3'>
//           <div className='input-group flex-nowrap'>
//             <span className='input-group-text text-theme fw-bold'>{t('الموقع')}</span>

//             <Select
//               classNamePrefix='react-select'
//               className='w-100'
//               // isLoading={loading3}
//               isSearchable={true}
//               isClearable
//               options={LocationsOptions}
//               placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//             />
//           </div>
//         </div>
//         <div className='col-lg-4 mb-3'>
//           <div className='input-group flex-nowrap'>
//             <span className='input-group-text text-theme fw-bold'>{t('الوظيقة')}</span>

//             <Select
//               classNamePrefix='react-select'
//               className='w-100'
//               // isLoading={loading3}
//               isSearchable={true}
//               isClearable
//               options={JobsOptions}
//               placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//             />
//           </div>
//         </div>
//         <div className='col-lg-4 mb-3'>
//           <div className='input-group flex-nowrap'>
//             <span className='input-group-text text-theme fw-bold'>{t('الدرجة الوظيفيـة')}</span>

//             <Select
//               classNamePrefix='react-select'
//               className='w-100'
//               // isLoading={loading3}
//               isSearchable={true}
//               isClearable
//               options={GradesOptions}
//               placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//             />
//           </div>
//         </div>
//         <div className='col-lg-4 mb-3'>
//           <div className='input-group flex-nowrap'>
//             <span className='input-group-text text-theme fw-bold'>{t('مجموعة الموظفيـن')}</span>

//             <Select
//               classNamePrefix='react-select'
//               className='w-100'
//               // isLoading={loading3}
//               isSearchable={true}
//               isClearable
//               options={GroupEmpsOptions}
//               placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//             />
//           </div>
//         </div>
//       </div>
//       <NtxTable
//         data={tableData || []}
//         columns={columns}
//         dataPerPage={10}
//         theadClass=''
//         tableClass='table text-nowrap table-hover '
//         // enableSearch
//         // showRecordsSelector
//       />
//     </>
//   );
// };

const Partial = ({ Persons, onIdsChange }) => {
  const { t, i18n } = useTranslation();
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectedFilterKey, setSelectedFilterKey] = useState(null); // الفلتر النشط
  const [selectedFilterValue, setSelectedFilterValue] = useState(null); // القيمة المختارة

  const { PositionsOptions } = useGetPositions();
  const { LocationsOptions } = useGetLocations();
  const { OrganizationOptions } = useGetOrganizations();
  const { JobsOptions } = useGetJobs();
  const { GradesOptions } = useGetGrade();
  const { GroupEmpsOptions } = useGetGroupEmp();

  useEffect(() => {
    if (onIdsChange) {
      onIdsChange(selectedIds);
    }
  }, [selectedIds, onIdsChange]);

  const handleCheckboxChange = item => {
    
    console.log('item', item);
    

    setSelectedIds(prev =>
      prev.includes(item.assignmentId)
        ? prev.filter(f => f !== item.assignmentId)
        : [...prev, item.assignmentId]
    );
  };

  // const handleSelectAll = event => {
  //   if (event.target.checked) {
  //     setSelectedIds(filteredPersons.map(item => item.assignmentId));
  //     // setSelectedIds(Persons.map(item => item.assignmentId));
  //   } else {
  //     setSelectedIds([]);
  //   }
  // };

  const handleSelectAll = e => {
    if (e.target.checked) {
      const selectableIds = filteredPersons
        .filter(person => !person.hasRun) // ✅ فقط غير المدفوعين
        .map(person => person.assignmentId);
      setSelectedIds(selectableIds);
    } else {
      setSelectedIds([]);
    }
  };

  const availableFilters = [
    {
      key: 'organization',
      label: t('الإدارة'),
      options: OrganizationOptions,
      field: 'organizationId'
    },
    { key: 'position', label: t('المنصب'), options: PositionsOptions, field: 'positionId' },
    { key: 'location', label: t('الموقع'), options: LocationsOptions, field: 'locationId' },
    { key: 'job', label: t('الوظيفة'), options: JobsOptions, field: 'jobId' },
    { key: 'grade', label: t('الدرجة الوظيفيـة'), options: GradesOptions, field: 'gradeId' },
    {
      key: 'groupEmp',
      label: t('مجموعة الموظفيـن'),
      options: GroupEmpsOptions,
      field: 'groupEmpId'
    }
  ];

  const activeFilter = availableFilters.find(f => f.key === selectedFilterKey);

  // تصفية الموظفين حسب الفلتر المختار
  const filteredPersons =
    selectedFilterKey && selectedFilterValue
      ? Persons.filter(person => person[activeFilter?.field] === selectedFilterValue.value)
      : Persons;

  const columns = [
    {
      title: (
        <input
          className='form-check-input'
          type='checkbox'
          onChange={handleSelectAll}
          // checked={selectedIds.length === filteredPersons?.length && filteredPersons?.length > 0}
          checked={
            filteredPersons?.filter(p => !p.hasRun).length > 0 &&
            filteredPersons?.filter(p => !p.hasRun).every(p => selectedIds.includes(p.assignmentId))
          }
        />
      ),
      key: 'checkBox',
      sortable: false
    },
    { title: t('EmployeeName'), key: 'Name' },
    { title: t('EmployeeNumber'), key: 'num' },
    { title: t('Payroll'), key: 'Payroll' },
    { title: t('Status'), key: 'hasRun' }
  ];

  const tableData = filteredPersons?.map(item => ({
    checkBox: (
      <input
        className='form-check-input  '
        type='checkbox'
        checked={selectedIds.includes(item.assignmentId)}
        onChange={() => handleCheckboxChange(item)}
        disabled={item.hasRun}
      />
    ),
    Name: i18n.language === 'ar' ? item.personName2 : item.personName,
    num: item.employeeNumber,
    Payroll: i18n.language === 'ar' ? item.payrollName2 : item.payrollName,
    hasRun: (
      <div className='d-flex align-items-center'>
        <span className={`badge ${item.hasRun ? 'bg-success' : 'bg-danger'} me-2`}>
          {item.hasRun ? t('Paid') : t('Unpaid')}
        </span>
      </div>
    ),
    assignmentId: item.assignmentId
  }));

  // دالة renderRow مخصصة لجعل الصف كامل قابل للنقر
  // const renderRow = (row, rowIndex) => {
  //   // console.log('row', row);

  //   return (
  //     <tr
  //       key={rowIndex}
  //       className={row.rowClass}
  //       onClick={() => handleCheckboxChange(row)}
  //       style={{ cursor: 'pointer' }}
  //     >
  //       {columns.map(column => (
  //         <td key={column.key} className={'align-middle ' + (column.className || '')}>
  //           {row[column.key]}
  //         </td>
  //       ))}
  //     </tr>
  //   );
  // };

  return (
    <>
      {/* ✅ اختيار نوع الفلتر */}
      <div className='mb-3 row '>
        <div className='col-lg-11'>
          <div className='input-group'>
            {/* نوع الفلتر */}
            <div className='input-group-text p-0 w-25'>
              <Select
                // isClearable
                classNamePrefix='react-select'
                className='react-select-container w-100'
                options={availableFilters.map(f => ({
                  value: f.key,
                  label: f.label
                }))}
                placeholder={i18n.language === 'ar' ? 'اختر نوع الفلتر' : 'Choose filter'}
                onChange={option => {
                  setSelectedFilterKey(option?.value || null);
                  setSelectedFilterValue(null);
                  setSelectedIds([]);
                }}
                value={
                  availableFilters
                    ?.map(f => ({
                      value: f.key,
                      label: f.label
                    }))
                    ?.find(f => f.value === selectedFilterKey) || null
                }
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: base => ({ ...base, zIndex: 9999 })
                }}
              />
            </div>

            {/* قيمة الفلتر */}
            <div className='form-control p-0 w-75  '>
              {activeFilter && (
                <Select
                  isClearable
                  classNamePrefix='react-select'
                  className='react-select-container w-100'
                  options={activeFilter.options}
                  placeholder={i18n.language === 'ar' ? 'اختر' : 'Choose'}
                  value={selectedFilterValue}
                  onChange={option => {
                    setSelectedFilterValue(option || null);
                    setSelectedIds([]);
                  }}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: base => ({ ...base, zIndex: 9999 })
                  }}
                />
              )}
            </div>
          </div>
        </div>
        <div className='col-lg-1'>
          <button
            type='button'
            className='btn btn-outline-secondary w-100'
            onClick={() => {
              setSelectedFilterKey(null);
              setSelectedFilterValue(null);
              setSelectedIds([]);
            }}
          >
            {i18n.language === 'ar' ? 'إعادة تعيين' : 'Reset'}
          </button>
        </div>
      </div>

      {/* ✅ جدول الموظفين */}
      <NtxTable
        data={tableData || []}
        columns={columns}
        dataPerPage={10}
        theadClass=''
        tableClass='table text-nowrap table-hover'
        // renderRow={renderRow}
      />
    </>
  );
};

export default Partial;

{
  /* <style>
        {`
          body .react-select__control {
          border-radius: 0px;
          }

          .form-check-input {
              width: 1.8em;
              height: 1.8em;
          }
          `}
      </style> */
}

// فلاتر متعددة
// const Partial = ({ Persons, onIdsChange }) => {
//   const { t, i18n } = useTranslation();
//   const [selectedIds, setSelectedIds] = useState([]);
//   const [activeFilters, setActiveFilters] = useState([]);
//   const [showFilterDropdown, setShowFilterDropdown] = useState(false);
//   const [searchQuery, setSearchQuery] = useState('');

//   const { PositionsOptions } = useGetPositions();
//   const { LocationsOptions } = useGetLocations();
//   const { OrganizationOptions } = useGetOrganizations();
//   const { JobsOptions } = useGetJobs();
//   const { GradesOptions } = useGetGrade();
//   const { GroupEmpsOptions } = useGetGroupEmp();

//   useEffect(() => {
//     if (onIdsChange) onIdsChange(selectedIds);
//   }, [selectedIds, onIdsChange]);

//   const handleCheckboxChange = id => {
//     setSelectedIds(prev =>
//       prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]
//     );
//   };

//   const handleSelectAll = event => {
//     setSelectedIds(event.target.checked ? Persons.map(p => p.assignmentId) : []);
//   };

//   const handleFilterToggle = key => {
//     setActiveFilters(prev =>
//       prev.includes(key) ? prev.filter(k => k !== key) : [...prev, key]
//     );
//   };

//   const availableFilters = [
//     { key: 'organization', label: t('الإدارة'), options: OrganizationOptions },
//     { key: 'position', label: t('المنصب'), options: PositionsOptions },
//     { key: 'location', label: t('الموقع'), options: LocationsOptions },
//     { key: 'job', label: t('الوظيفة'), options: JobsOptions },
//     { key: 'grade', label: t('الدرجة الوظيفيـة'), options: GradesOptions },
//     { key: 'groupEmp', label: t('مجموعة الموظفيـن'), options: GroupEmpsOptions }
//   ];

//   const columns = [
//     {
//       title: (
//         <input
//           className='form-check-input'
//           type='checkbox'
//           onChange={handleSelectAll}
//           checked={selectedIds.length === Persons?.length && Persons?.length > 0}
//         />
//       ),
//       key: 'checkBox',
//       sortable: false
//     },
//     { title: t('EmployeeName'), key: 'Name' },
//     { title: t('EmployeeNumber'), key: 'num' },
//     { title: t('Payroll'), key: 'Payroll' }
//   ];

//   const tableData = Persons?.filter(item => {
//     const name = i18n.language === 'ar' ? item.personName2 : item.personName;
//     return name?.toLowerCase().includes(searchQuery.toLowerCase());
//   }).map(item => ({
//     checkBox: (
//       <input
//         className='form-check-input'
//         type='checkbox'
//         checked={selectedIds.includes(item.assignmentId)}
//         onChange={() => handleCheckboxChange(item.assignmentId)}
//       />
//     ),
//     Name: i18n.language === 'ar' ? item.personName2 : item.personName,
//     num: item.employeeNumber,
//     Payroll: i18n.language === 'ar' ? item.payrollName2 : item.payrollName
//   }));

//   return (
//     <>
//       {/* ✅ Top filter bar */}
//       <div className='d-flex align-items-center gap-2 mb-3'>
//         <div className='dropdown'>
//           <button
//             className='btn btn-secondary dropdown-toggle'
//             type='button'
//             onClick={() => setShowFilterDropdown(!showFilterDropdown)}
//           >
//             {t('Filter')}
//           </button>
//           {showFilterDropdown && (
//             <div className='dropdown-menu show p-2' style={{ minWidth: '250px' }}>
//               {availableFilters.map(filter => (
//                 <div key={filter.key} className='form-check'>
//                   <input
//                     type='checkbox'
//                     className='form-check-input'
//                     id={`filter-${filter.key}`}
//                     checked={activeFilters.includes(filter.key)}
//                     onChange={() => handleFilterToggle(filter.key)}
//                   />
//                   <label className='form-check-label' htmlFor={`filter-${filter.key}`}>
//                     {filter.label}
//                   </label>
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>

//         <div className='input-group w-50'>
//           <span className='input-group-text'>
//             <i className='bi bi-search'></i>
//           </span>
//           <input
//             type='text'
//             className='form-control'
//             placeholder={t('Search')}
//             value={searchQuery}
//             onChange={e => setSearchQuery(e.target.value)}
//           />
//         </div>
//       </div>

//       {/* ✅ الفلاتر المختارة */}
//       <div className='row'>
//         {availableFilters
//           .filter(filter => activeFilters.includes(filter.key))
//           .map(filter => (
//             <div key={filter.key} className='col-lg-4 mb-3'>
//               <div className='input-group flex-nowrap'>
//                 <span className='input-group-text text-theme fw-bold'>{filter.label}</span>
//                 <Select
//                   classNamePrefix='react-select'
//                   className='w-100'
//                   isSearchable
//                   isClearable
//                   options={filter.options}
//                   placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//                 />
//               </div>
//             </div>
//           ))}
//       </div>

//       {/* ✅ جدول الموظفين */}
//       <NtxTable
//         data={tableData || []}
//         columns={columns}
//         dataPerPage={10}
//         theadClass=''
//         tableClass='table text-nowrap table-hover'
//       />
//     </>
//   );
// };
